import { useQuery } from "@tanstack/react-query";
import { fetchTeamLeaderAnalytics, type AnalyticsFilters } from "@/lib/api";
import { useAuth } from "@/hooks/use-auth";

export function useTeamLeaderAnalytics(filters: AnalyticsFilters) {
  const { hasPermission } = useAuth();

  return useQuery({
    queryKey: ["analytics", "team-leaders", filters],
    queryFn: () => fetchTeamLeaderAnalytics(filters),
    enabled: hasPermission("view:analytics"),
  });
}
